import React, { Component } from "react";
import RequestPasswordResetForm from "../../components/Forms/RequestResetPasswordForm";

class RequestResetPassword extends Component {
  render() {
    return <RequestPasswordResetForm />;
  }
}

export default RequestResetPassword;
